import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { superAdmin } from "../../api";
import { StatCard, PageHeader, Btn, LoadingSpinner } from "../../components/ui";
import { useAuth } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";

export default function SuperAdminDashboard() {
  const { user }   = useAuth();
  const navigate   = useNavigate();
  const { theme }  = useTheme();
  const isDark     = theme === "dark";
  const styles     = getStyles(isDark);
  const [stats, setStats]     = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    superAdmin.platformStats()
      .then(r => setStats(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={styles.root}>
      <PageHeader
        title={`Good ${greeting()}, ${user?.name?.split(" ")[0]}`}
        subtitle="Here's what's happening across the platform right now."
        action={
          <Btn onClick={() => navigate("/super-admin/facilities")} size="lg">
            + New Facility
          </Btn>
        }
      />

      {loading ? <LoadingSpinner /> : (
        <>
          {/* Stats row */}
          <div style={styles.statsRow}>
            <StatCard label="Total Facilities" value={stats?.total_facilities}     color="#60A5FA" icon="🏥" />
            <StatCard label="Active"            value={stats?.active_facilities}    color="#22C55E" icon="✅" />
            <StatCard label="Trial"             value={stats?.trial_facilities}     color="#EAB308" icon="⏳" />
            <StatCard label="Suspended"         value={stats?.suspended_facilities} color="#EF4444" icon="⛔" />
            <StatCard label="Tickets Today"     value={stats?.tickets_today}        color="#A78BFA" icon="🎫" />
            <StatCard label="Tickets This Month" value={stats?.tickets_this_month}  color="#F472B6" icon="📅" />
          </div>

          {/* Quick links */}
          <div style={styles.quickLinks}>
            <QuickLink
              icon="🏥" title="Manage Facilities"
              desc="Create, suspend, or configure facilities"
              onClick={() => navigate("/super-admin/facilities")}
            />
            <QuickLink
              icon="👥" title="Manage Users"
              desc="View, reset passwords, deactivate accounts"
              onClick={() => navigate("/super-admin/users")}
            />
          </div>
        </>
      )}
    </div>
  );
}

function QuickLink({ icon, title, desc, onClick }) {
  const { theme } = useTheme();
  const styles = getStyles(theme === "dark");
  return (
    <button onClick={onClick} style={styles.quickLink}>
      <span style={styles.qlIcon}>{icon}</span>
      <div>
        <div style={styles.qlTitle}>{title}</div>
        <div style={styles.qlDesc}>{desc}</div>
      </div>
      <span style={styles.qlArrow}>›</span>
    </button>
  );
}

function greeting() {
  const h = new Date().getHours();
  if (h < 12) return "morning";
  if (h < 17) return "afternoon";
  return "evening";
}

function getStyles(isDark) {
  return {
    root: {
      padding: "32px",
      fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
      maxWidth: "1200px",
    },
    statsRow: {
      display: "flex",
      gap: "14px",
      flexWrap: "wrap",
      marginBottom: "28px",
    },
    quickLinks: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
      gap: "14px",
    },
    quickLink: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      background: isDark ? "var(--surface-bg)" : "#FFFFFF",
      border: isDark ? "1px solid rgba(37,99,235,0.15)" : "1px solid #E2E8F0",
      boxShadow: isDark ? "none" : "0 1px 3px var(--surface-bg)",
      borderRadius: "14px",
      padding: "20px",
      cursor: "pointer",
      textAlign: "left",
      transition: "border-color 0.15s, background 0.15s",
      width: "100%",
      fontFamily: "inherit",
    },
    qlIcon:  { fontSize: "28px", flexShrink: 0 },
    qlTitle: { fontSize: "15px", fontWeight: "600", color: isDark ? "#E2E8F0" : "#0F1E3D", marginBottom: "3px" },
    qlDesc:  { fontSize: "13px", color: isDark ? "#475569" : "#94A3B8" },
    qlArrow: { marginLeft: "auto", fontSize: "22px", color: "#2563EB", flexShrink: 0 },
  };
}
